import React from 'react';
import { Card, CardContent } from '../ui/card';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../ui/hover-card';
import { Calendar, TrendingUp, CheckCircle, Users, RefreshCw, Clock, Wallet, XCircle, Cpu } from 'lucide-react';
import { formatCurrency } from './SubscriptionDialogs';

const Stat = ({ icon: Icon, iconClass, label, value, sub, valueClass = 'text-gray-800', testId }) => (
  <Card className="h-full">
    <CardContent className="p-4">
      <div className="flex items-center gap-2 mb-2">
        <Icon className={`w-4 h-4 ${iconClass}`} />
        <span className="text-xs text-gray-500">{label}</span>
      </div>
      <div className={`text-lg font-bold ${valueClass}`} data-testid={testId}>{value}</div>
      {sub && <div className="text-xs text-gray-400 mt-0.5">{sub}</div>}
    </CardContent>
  </Card>
);

function NotRenewingCard({ summary, onOpenCase }) {
  const list = summary.not_renewing || [];
  return (
    <HoverCard openDelay={100} closeDelay={150}>
      <HoverCardTrigger asChild>
        <div className="cursor-pointer" tabIndex={0} data-testid="summary-not-renewing-trigger">
          <Stat icon={XCircle} iconClass="text-red-500" label="Yenilemeyecek Müşteri" valueClass="text-red-600"
            value={summary.not_renewing_customers} sub={`${summary.not_renewing_devices} cihaz • detay için üzerine gelin`} testId="summary-not-renewing" />
        </div>
      </HoverCardTrigger>
      <HoverCardContent className="w-96 p-0" align="end" data-testid="summary-not-renewing-list">
        <div className="px-4 py-2 border-b text-sm font-semibold text-gray-700">Yenilenmeyecek cihazlar</div>
        {list.length === 0 ? (
          <p className="px-4 py-4 text-sm text-gray-500">Yenilemeyecek müşteri yok</p>
        ) : (
          <div className="max-h-80 overflow-y-auto divide-y">
            {list.map(item => (
              <button key={item.case_id} type="button" onClick={() => onOpenCase(item.case_id)}
                className="w-full text-left px-4 py-2 hover:bg-gray-50" data-testid={`not-renewing-item-${item.case_id}`}>
                <div className="flex justify-between gap-2">
                  <span className="text-sm font-medium text-gray-800 truncate">{item.customer_name}</span>
                  <span className="text-xs text-red-600 whitespace-nowrap">{item.device_count} cihaz</span>
                </div>
                {item.reason && <p className="text-xs text-gray-500">Neden: {item.reason}</p>}
                {item.devices.length > 0 && <p className="text-xs text-gray-500 mt-0.5 break-words">{item.devices.join(', ')}</p>}
              </button>
            ))}
          </div>
        )}
      </HoverCardContent>
    </HoverCard>
  );
}

export function SubscriptionSummaryCards({ summary, onOpenCase }) {
  const t = summary.term_devices || {};
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6" data-testid="subscription-summary-cards">
      <Stat icon={Calendar} iconClass="text-gray-400" label="Toplam Cihaz" value={summary.total_devices} testId="summary-total-devices" />
      <Stat icon={TrendingUp} iconClass="text-gray-400" label="Beklenen Gelir" value={formatCurrency(summary.total_expected_revenue)} testId="summary-expected" />
      <Stat icon={Users} iconClass="text-green-500" label="Yenilenen Müşteri" valueClass="text-green-600" value={summary.renewed_customers} testId="summary-renewed-customers" />
      <Stat icon={Cpu} iconClass="text-green-500" label="Yenilenen Cihaz Adedi" valueClass="text-green-600" value={summary.total_renewed_devices}
        sub={`%${String(summary.renewal_percentage).replace('.', ',')} • ${formatCurrency(summary.total_renewed_amount)}`} testId="summary-renewed-devices" />
      <Stat icon={RefreshCw} iconClass="text-blue-500" label="Yenileme Süresi (cihaz)" testId="summary-term-devices"
        value={<div className="flex gap-3 text-base">{['1', '2', '3'].map(k => <span key={k}><span className="text-xs font-normal text-gray-500">{k}Y</span> {t[k] || 0}</span>)}</div>} />
      <Stat icon={CheckCircle} iconClass="text-emerald-500" label="Tahsil Edilen" valueClass="text-emerald-600" value={formatCurrency(summary.total_collected)}
        sub={`%${String(summary.collection_percentage).replace('.', ',')}`} testId="summary-collected" />
      <Stat icon={Clock} iconClass="text-amber-500" label="Ödeme Bekleyen" valueClass="text-amber-600" value={summary.payment_pending_customers} sub="müşteri" testId="summary-payment-pending" />
      <Stat icon={Wallet} iconClass="text-amber-500" label="Kalan Tahsilat" valueClass="text-amber-600" value={formatCurrency(summary.remaining_balance)} testId="summary-remaining" />
      <NotRenewingCard summary={summary} onOpenCase={onOpenCase} />
    </div>
  );
}
